{
  "actions": "Aktionen",
  "hideButtonLabel": "Weniger zeigen",
  "showAllButtonLabel": "Alle anzeigen ({tagCount, number})"
}
